export default __webpack_public_path__ + "static/media/may.a461411c.jpg";